export const SORT_BY_DATE = (list: Array<any>, key: string): Array<any> => {
	return list.sort((a: any, b: any) => {
		return new Date(b[key]).valueOf() - new Date(a[key]).valueOf();
	});
};

export const SORT_BY_KEY = (list: Array<any>, key: string): Array<any> => {
	return list.sort((a: any, b: any) => (a[key] > b[key] ? 1 : -1));
};

export const COMPARE = (a: number | string, b: number | string, isAsc: boolean): any => {
	return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
};
